import React, { useMemo } from 'react';
import _ from 'underscore';
import { useParams } from 'react-router-dom';

import { EditImagePageComponent } from '@bingads-webui-campaign-react/ads-studio-app-components';
import { MediaRepository } from '@bingads-webui-campaign/media-repository';
import { getSmartCropSettingsFactory } from '@bingads-webui-campaign-react/unified-ad-preview-library-cmui';
import { MultiLineEllipsisText } from '@bingads-webui-react/multiline-ellipsis';

import { notificationApi } from '../../adapters/get-notification';

export const EditImagePage = (props) => {
  const {
    aid, cid, oDataConfig, logger,
  } = props;
  const { imageId } = useParams();
  const mediaRepository = useMemo(() => new MediaRepository({
    cid, aid, oDataConfig,
  }), [aid, cid, oDataConfig]);

  const getSmartCroppings = useMemo(
    () => getSmartCropSettingsFactory(mediaRepository, { trace: logger ? logger.traceWithoutParams : _.noop }),
    [logger, mediaRepository]
  );
  return <EditImagePageComponent imageId={imageId} {...props} getSmartCroppings={getSmartCroppings} MultiLineEllipsisText={MultiLineEllipsisText} notificationApi={notificationApi} />;
};
